import { useEffect, useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import Layout from "../utils/Layout";
import AlertBar from "../utils/AlertBar";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../config/environment";
import { useTranslation } from "react-i18next";
import { useTitle } from "../utils/useTitle";

const AccountVerification = () => {
  useTitle("Account Verification");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { token } = useParams();
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [verificationSucceed, setVerificationSucceed] = useState(false);

  const handleButtonClick = async () => {
    try {
      navigate("/signin");
    } catch (error) {
      console.error("Error:", error);
      setErrors({ error: true });
      setErrorMessage(t("auth.alertMsg.error4"));
    }
  };

  //   const handleResendConfirmationEmail = async () => {};

  const verifyConfirmationToken = async () => {
    if (!token) {
      setErrors({ error: true });
      setErrorMessage(t("auth.alertMsg.error5"));
      return;
    }

    // Placeholder for the API request logic
    const url = `${API_URL}/auth/verifyAccount/${token}`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      console.log(data);

      if (data.status === "success") {
        // navigate("/account-confirm");
        setVerificationSucceed(true);
      } else {
        setErrors({ error: true });
        setErrorMessage(t("auth.alertMsg.error6"));
        return;
      }
    } catch (error) {
      console.error("Error:", error);
      setErrors({ error: true });
      setErrorMessage(t("auth.alertMsg.error7"));
    }
  };

  useEffect(() => {
    const verifyToken = async () => {
      await verifyConfirmationToken();
      //   setIngredients(ingredients);
      //   setLoading(false);
    };

    verifyToken();
  }, []);

  return (
    <Layout>
      <Grid container columns={15} sx={{ marginTop: "250px" }}>
        <Grid item xs={5} />
        <Grid item xs={5} container justify="center" alignItems="center">
          <Grid
            container
            direction="column"
            spacing={3}
            style={{ maxWidth: "800px" }}
          >
            <Grid item>
              <h1>
                {verificationSucceed
                  ? t("auth.header.verificationSuccess")
                  : t("auth.header.verificationFailed")}
              </h1>
              <Typography variant="h5" gutterBottom>
                {verificationSucceed
                  ? t("auth.msg.verificationSuccess")
                  : t("auth.msg.verificationFailed")}
              </Typography>
            </Grid>
            <Grid item>
              {verificationSucceed ? (
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                  size="large"
                  style={{ height: "55px" }}
                  onClick={handleButtonClick}
                >
                  {t("auth.btnText.verificationSuccess")}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                  size="large"
                  style={{ height: "55px" }}
                  onClick={() => {
                    navigate("/send-confirmation-email");
                  }}
                >
                  {t("auth.btnText.verificationFailed")}
                </Button>
              )}
            </Grid>

            <Grid item></Grid>
          </Grid>
        </Grid>

        <Grid item xs={5} />
      </Grid>

      <AlertBar
        open={Object.values(errors).some((error) => error)}
        message={errorMessage}
        severity={"error"}
        onClose={() => setErrors({})}
      />
    </Layout>
  );
};

export default AccountVerification;
